import LocalCheckoutPage from './LocalCheckoutPage';

export default LocalCheckoutPage;
